<div class="p-4 md:p-6 max-w-6xl mx-auto">
  <!-- Header -->
  <div class="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 mb-6">
    <div class="flex items-center gap-3">
      <mat-icon style="color: #1C593D; font-size: 28px; width: 28px; height: 28px;">account_balance</mat-icon>
      <h1 class="text-xl md:text-2xl font-bold text-gray-800">Cuentas Activas VES</h1>
    </div>
    <button type="button" (click)="openCreateDialog()"
      style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 20px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
      onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
      <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">add</mat-icon>
      Agregar cuenta de trabajo
    </button>
  </div>

  <!-- Tabla Desktop -->
  <div class="hidden lg:block bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden">
    <div class="overflow-x-auto">
      <table mat-table [dataSource]="listaCuentas" class="w-full">

        <ng-container matColumnDef="nombre">
          <th mat-header-cell *matHeaderCellDef>Nombre</th>
          <td mat-cell *matCellDef="let cuenta">
            <span class="text-xs font-semibold text-gray-800">{{ cuenta.nombre }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="apellidos">
          <th mat-header-cell *matHeaderCellDef>Apellidos</th>
          <td mat-cell *matCellDef="let cuenta">
            <span class="text-xs text-gray-700">{{ cuenta.apellidos }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="banco">
          <th mat-header-cell *matHeaderCellDef>Banco</th>
          <td mat-cell *matCellDef="let cuenta">
            <span class="text-xs text-gray-700">{{ cuenta.banco?.nombre }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="pais">
          <th mat-header-cell *matHeaderCellDef>País</th>
          <td mat-cell *matCellDef="let cuenta">
            <span class="text-xs font-mono">{{ cuenta.banco?.codigoPais }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="tipoCuenta">
          <th mat-header-cell *matHeaderCellDef>Tipo Cuenta</th>
          <td mat-cell *matCellDef="let cuenta">
            <span class="text-xs text-gray-700">{{ cuenta.tipoCuenta?.nombre }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="numeroCuenta">
          <th mat-header-cell *matHeaderCellDef>Número Cuenta</th>
          <td mat-cell *matCellDef="let cuenta">
            <span class="text-xs font-mono text-gray-700">{{ cuenta.numeroCuenta }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="activa">
          <th mat-header-cell *matHeaderCellDef style="text-align: center;">Activa</th>
          <td mat-cell *matCellDef="let cuenta" style="text-align: center;">
            <mat-checkbox
              [checked]="cuenta.activaEnVes"
              (change)="toggleActiva(cuenta)"
              color="primary">
            </mat-checkbox>
          </td>
        </ng-container>

        <ng-container matColumnDef="asignacionMaestra">
          <th mat-header-cell *matHeaderCellDef style="text-align: center;">Asig. Maestra</th>
          <td mat-cell *matCellDef="let cuenta" style="text-align: center;">
            <mat-checkbox
              [checked]="esMaestra(cuenta)"
              [disabled]="esMaestraDisabled(cuenta)"
              (change)="toggleAsignacionMaestra(cuenta)"
              color="warn">
            </mat-checkbox>
          </td>
        </ng-container>

        <ng-container matColumnDef="acciones">
          <th mat-header-cell *matHeaderCellDef style="text-align: center; width: 70px;">Acciones</th>
          <td mat-cell *matCellDef="let cuenta" style="text-align: center; width: 70px;">
            <button title="Editar" (click)="openCreateDialog(cuenta)"
              style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #bfdbfe; border-radius: 6px; background: #eff6ff; cursor: pointer;"
              onmouseover="this.style.background='#dbeafe'" onmouseout="this.style.background='#eff6ff'">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #2563eb;">edit</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell text-center py-4 text-sm text-gray-400" [attr.colspan]="displayedColumns.length">
            No hay cuentas disponibles
          </td>
        </tr>
      </table>
    </div>
  </div>

  <!-- Cards Mobile -->
  <div class="lg:hidden space-y-3">
    <div *ngIf="listaCuentas.length === 0" class="text-center text-sm text-gray-400 py-8">
      No hay cuentas disponibles
    </div>
    <div *ngFor="let cuenta of listaCuentas; let i = index"
      class="bg-white rounded-xl shadow-sm border overflow-hidden transition-all duration-200"
      [style.borderColor]="expandedCardId === i ? '#1C593D' : '#e5e7eb'">

      <div class="flex items-center justify-between p-3 cursor-pointer"
        (click)="toggleCard(i)"
        [style.background]="expandedCardId === i ? '#f0fdf4' : 'white'">
        <div class="flex items-center gap-2 flex-1 min-w-0">
          <mat-checkbox
            (click)="$event.stopPropagation()"
            [checked]="cuenta.activaEnVes"
            (change)="toggleActiva(cuenta)"
            color="primary">
          </mat-checkbox>
          <span class="text-xs font-semibold text-gray-800 truncate">{{ cuenta.nombre }} {{ cuenta.apellidos }}</span>
          <span class="text-xs text-gray-500 shrink-0">{{ cuenta.banco?.nombre }}</span>
        </div>
        <mat-checkbox
          (click)="$event.stopPropagation()"
          [checked]="esMaestra(cuenta)"
          [disabled]="esMaestraDisabled(cuenta)"
          (change)="toggleAsignacionMaestra(cuenta)"
          color="warn"
          matTooltip="Asignación Maestra"
          class="shrink-0">
        </mat-checkbox>
        <mat-icon class="text-gray-400 shrink-0 transition-transform duration-200"
          [style.transform]="expandedCardId === i ? 'rotate(180deg)' : 'rotate(0)'">
          expand_more
        </mat-icon>
      </div>

      <div *ngIf="expandedCardId === i" class="px-3 pb-3 border-t border-gray-100">
        <div class="grid grid-cols-2 gap-2 mt-3 text-xs">
          <div>
            <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">País</span>
            <p class="text-gray-700 font-mono font-medium mt-0.5">{{ cuenta.banco?.codigoPais }}</p>
          </div>
          <div>
            <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Tipo Cuenta</span>
            <p class="text-gray-700 font-medium mt-0.5">{{ cuenta.tipoCuenta?.nombre }}</p>
          </div>
          <div class="col-span-2">
            <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Número Cuenta</span>
            <p class="text-gray-700 font-mono font-medium mt-0.5">{{ cuenta.numeroCuenta }}</p>
          </div>
        </div>
        <div class="flex gap-2 mt-3 pt-3 border-t border-gray-100">
          <button title="Editar" (click)="openCreateDialog(cuenta)"
            style="display: inline-flex; align-items: center; gap: 4px; padding: 6px 12px; border: 1px solid #bfdbfe; border-radius: 8px; background: #eff6ff; cursor: pointer; font-size: 0.75rem; font-weight: 600; color: #2563eb;">
            <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #2563eb;">edit</mat-icon>
            Editar
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
